import type { 
  PostAuthLoginData, 
  PostAuthLoginResponse,

  PostAuthLogoutData,
  PostAuthLogoutResponse,

  PostAuthTotpData,
  PostAuthTotpResponse,

  PostAuthSignificantActionsLockData,
  PostAuthSignificantActionsLockResponse,

  PostAuthSignificantActionsUnlockData,
  PostAuthSignificantActionsUnlockResponse
} from "@/types/openapi-ts";

import type { AxiosInstance } from "axios";

export function getAuthApiModule(affiliatesApi: AxiosInstance) {
  return {
    signIn(payload: PostAuthLoginData['body']) {
      return affiliatesApi.post<PostAuthLoginResponse>('/auth/login', payload);
    },
    signOut() {
      return affiliatesApi.post<PostAuthLogoutResponse>('/auth/logout');
    },
    confirm2fa(payload: PostAuthTotpData['body']) {
      return affiliatesApi.post<PostAuthTotpResponse>('/auth/totp', payload);
    },
    significantLock() {
      return affiliatesApi.post<PostAuthSignificantActionsLockResponse>('/auth/significant-actions/lock');
    },
    significantUnlock(payload: PostAuthSignificantActionsUnlockData['body']) {
      return affiliatesApi.post<PostAuthSignificantActionsUnlockResponse>('/auth/significant-actions/unlock', payload);
    },
  };
}
